"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectsEqual = exports.ChildrenEqual = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Compare two objects using stringify
 * @returns {Boolean}
 */
var ObjectsEqual = function ObjectsEqual(val1, val2) {
  return JSON.stringify({
    a: val1
  }) === JSON.stringify({
    a: val2
  });
};
/**
 * Compare two children by keys
 * @returns {Boolean}
 */


exports.ObjectsEqual = ObjectsEqual;

var ChildrenEqual = function ChildrenEqual(val1, val2) {
  var keys1 = _react["default"].Children.map(val1, function (child) {
    return child.key;
  });

  var keys2 = _react["default"].Children.map(val2, function (child) {
    return child.key;
  }); // diferent size


  if (keys1.length !== keys2.length) return false; // check each key

  for (var i = 0; i < keys1.length; i++) {
    if (keys1[i] !== keys2[i]) return false;
  }

  return true;
};

exports.ChildrenEqual = ChildrenEqual;